import { motion } from "motion/react";
import { CSSProperties } from "react";
import { cn } from "@/core/helpers/cn";
import KeyActionPanel, { KeyAction } from "@/shared/ui/KeyActionPanel";
import KeyCode from "@/assets/constants/key-code";

type Props = {
  className?: string;
  style?: CSSProperties;
  actions: Map<KeyCode, KeyAction>;
};

export default function DeathScreenActionsContainer({ className, style, actions }: Props) {
  return (
    <motion.div
      initial={{ opacity: 0, translateY: "100%", translateX: "-50%" }}
      animate={{ opacity: 1, translateY: "0%" }}
      exit={{ opacity: 0, translateY: "100%" }}
      className={cn("flex items-center gap-2", className)}
      style={style}
    >
      <KeyActionPanel
        actions={actions}
        name="death-screen"
        className="fixed bottom-[--boundary-offset-y] left-[50%] -translate-x-[50%] z-[51]"
      />
    </motion.div>
  );
}
